var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0965 2.64452C10.6925 0.79623 13.3075 0.796228 13.9035 2.64452L15.5611 7.78505L20.9412 7.78505C22.875 7.78505 23.6829 10.2565 22.1226 11.3988L17.7569 14.5949L19.4214 19.7568C20.0164 21.6021 17.9009 23.1297 16.3365 21.9843L12 18.8096L7.66352 21.9843C6.09909 23.1297 3.98358 21.6021 4.5786 19.7568L6.24305 14.5949L1.87734 11.3988C0.31704 10.2565 1.12502 7.78505 3.05878 7.78505H8.43892L10.0965 2.64452ZM13.6576 8.39883L12 3.2583L10.3424 8.39883C10.076 9.22504 9.30702 9.78505 8.43892 9.78505H3.05878L7.42449 12.9812C8.12012 13.4905 8.41112 14.3882 8.14654 15.2087L6.48209 20.3706L10.8186 17.1959C11.522 16.6809 12.478 16.6809 13.1814 17.1959L17.5179 20.3706L15.8534 15.2087C15.5889 14.3882 15.8799 13.4905 16.5755 12.9812L20.9412 9.78505H15.5611C14.693 9.78505 13.924 9.22504 13.6576 8.39883Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cd3ed5f8597a2b768a404afb48b81539.svg";
export { ForwardRef as ReactComponent };